
import { Subject } from '../types';

export const SUBJECT_THEMES: Record<Subject, {
  id: string;
  bg: string;
  lightBg: string;
  text: string;
  border: string;
  icon: string;
  gradient: string;
  shadow: string;
}> = {
  [Subject.MATH]: {
    id: 'math',
    bg: 'bg-blue-600',
    lightBg: 'bg-blue-50',
    text: 'text-blue-700',
    border: 'border-blue-200',
    icon: 'fas fa-calculator',
    gradient: 'from-blue-500 to-indigo-600',
    shadow: 'shadow-blue-200'
  },
  [Subject.SCIENCE]: {
    id: 'science',
    bg: 'bg-emerald-500',
    lightBg: 'bg-emerald-50',
    text: 'text-emerald-700',
    border: 'border-emerald-200',
    icon: 'fas fa-flask',
    gradient: 'from-emerald-400 to-teal-600',
    shadow: 'shadow-emerald-200'
  },
  [Subject.LANGUAGE_ARTS]: {
    id: 'la',
    bg: 'bg-rose-500',
    lightBg: 'bg-rose-50',
    text: 'text-rose-700',
    border: 'border-rose-200',
    icon: 'fas fa-book-open',
    gradient: 'from-rose-400 to-pink-600',
    shadow: 'shadow-rose-200'
  },
  [Subject.SOCIAL_STUDIES]: {
    id: 'ss',
    bg: 'bg-amber-500',
    lightBg: 'bg-amber-50',
    text: 'text-amber-800',
    border: 'border-amber-200',
    icon: 'fas fa-globe-americas',
    gradient: 'from-amber-400 to-orange-600',
    shadow: 'shadow-amber-200'
  }
};

export const getTheme = (subject: Subject) => {
  return SUBJECT_THEMES[subject] || SUBJECT_THEMES[Subject.MATH];
};
